export { default } from "./HomeWallSplashRoot";
